export { InfiniteRowModelModule } from "./infiniteRowModelModule";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-community/infinite-row-model/dist/es6/main.js
// module id = 1148
// module chunks = 0